export const DMO_LIST_REQUEST = "DMO_LIST_REQUEST";
export const DMO_LIST_SUCCESS = "DMO_LIST_SUCCESS";
export const DMO_LIST_FAILURE = "DMO_LIST_FAILURE";



export const AUTHORITY_LIST_REQUEST = "AUTHORITY_LIST_REQUEST";
export const AUTHORITY_LIST_SUCCESS = "AUTHORITY_LIST_SUCCESS";
export const AUTHORITY_LIST_FAILURE = "AUTHORITY_LIST_FAILURE";
